
export enum SubPlantOperationStatusEnum {
    OPEN = 'OPEN',
    IN_TRANSIT = 'IN-TRANSIT',
    RECEIVED = 'RECEIVED',
}